import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import { UserMeReduxState } from '../../../../../interfaces/users';
import CheckInput, { InputType } from '../../../../../atoms/CheckInput';
import PurchasePaymentCard from './components/PurchasePaymentCard';
import LabeledContainer from '../../../../../molecules/common/LabeledContainer';
import { CardBrandList } from '../../../../../molecules/common/CardBrandList';
import css from './PaymentMethodsSelector.module.scss';
import { useSelector, shallowEqual } from 'react-redux';
import { getPurchases } from '../../../../../redux/selectors/merchants/products/purchases';
import { ReduxState } from '../../../../../redux/reducers';

interface Props {
  me: UserMeReduxState;
  selection?: IPurchases.PaymentSelection;
  onSelect: (selection: string) => void;
}

const PaymentMethodsSelector: React.FC<Props> = ({
  me,
  selection,
  onSelect,
}) => {
  const intl = useIntl();
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = e;
      onSelect(value);
    },
    [onSelect],
  );

  const merchantProductsPurchaseState = useSelector(
    (state: ReduxState) => getPurchases(state.merchantsProductsPurchases),
    shallowEqual,
  );

  const { jcbEnabled } = merchantProductsPurchaseState;

  return (
    <LabeledContainer
      label={intl.formatMessage({
        id: 'purchases.paymentMethodsSelector.pleaseSelect',
      })}
      paddingTop={true}
    >
      {me.creditCard && (
        <PurchasePaymentCard
          tailDigits={me.creditCard.tailDigits}
          value={IPurchases.PaymentSelection.UsedCreditCard}
          checked={selection === IPurchases.PaymentSelection.UsedCreditCard}
          onChange={handleChange}
        />
      )}
      <CheckInput
        type={InputType.Radio}
        value={IPurchases.PaymentSelection.AnotherCreditCard}
        checked={selection === IPurchases.PaymentSelection.AnotherCreditCard}
        onChange={handleChange}
        name="payment-creditcard"
      >
        {intl.formatMessage({
          id: 'purchases.paymentMethodsSelector.addNewCreditCard',
        })}
        <div className={css.card_brand_list_wrapper}>
          <CardBrandList isJCBEnabled={jcbEnabled} />
        </div>
      </CheckInput>
    </LabeledContainer>
  );
};

export default PaymentMethodsSelector;
